/* eslint-disable @typescript-eslint/no-explicit-any */
import { Spin } from 'antd';
import { BG_BUTTON, BTN_CANCEL } from 'assets/images';
import ButtonStyled from './styled';

interface ButtonProps {
  onClickButton: () => void
  buttonName: string | React.ReactNode
  disabled?: boolean
  width?: number
  btnCancel?: boolean,
  isLoading?: boolean
  height?: number
  classNames?: any
}

function ButtonCreate({
  onClickButton,
  buttonName,
  disabled,
  width = 215,
  btnCancel,
  isLoading,
  height = 65,
  classNames
}: ButtonProps) {

  const handleClick = () => {
    if (disabled || isLoading) return
    onClickButton()
  }

  return (
    <ButtonStyled className={classNames} >
      <div className={`btn-container-${disabled || isLoading ? 'disable' : ''}`} onClick={handleClick} >
        <img src={btnCancel ? BTN_CANCEL : BG_BUTTON} alt='' className='background-btn' width={width} height={height} />
        <span className='btn-name'>{isLoading && <Spin className='mt-2 mr-3' />}{buttonName}</span>
      </div>
    </ButtonStyled>
  )
}

export default ButtonCreate
